import type { RouteRecordRaw } from 'vue-router';
import { CUSTOMER_MGMT_V2_ROUTE_NAME } from '@/consts';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const customerMgmtV2Routes: RouteRecordRaw = {
  path: '/customer-mgmt-v2',
  component: () => import('@/layouts/main.vue'),
  meta: { requireAuth: true, requireStoreId: true, i18n },
  children: [
    {
      name: CUSTOMER_MGMT_V2_ROUTE_NAME.CUSTOMER_MGMT_V2,
      path: '',
      component: () => import('./CustomerMgmtV2.vue'),
      meta: {
        requireAuth: true,
      },
    },
  ],
};
